export default __webpack_public_path__ + "static/media/CineStar.c887df9d.jpg";